/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { DashboardTestSplitAction } from 'cio/utils/metrics/models/dashboard-tests';
import { action } from '@ember/object';
import { SortDirection } from 'cio/utils/sort';
import { findDenominator, MeasureType } from 'cio/utils/metrics/measure';
import { Measure } from 'cio/utils/metrics/common';
import { CampaignType } from 'cio/models/campaign';

interface DashboardPageTestsCardCampaignsRowArgs {
  splitAction: DashboardTestSplitAction;
  sortByItem: {
    label: string;
    value: string;
    sortBy: string;
    sortByDirection: SortDirection;
  };
  ctboMeasureName: 'opened' | 'clicked' | 'converted';
  trackNavigate: (destination: string) => unknown;
}

export default class DashboardPageTestsCampaignsRowCard extends Component<DashboardPageTestsCardCampaignsRowArgs> {
  get denominator() {
    return findDenominator(this.args.ctboMeasureName as Measure, MeasureType.DeliveryMetrics, 'email_action');
  }

  get original() {
    return this.args.splitAction.splitMetrics[0];
  }

  get variation() {
    return this.args.splitAction.splitMetrics[1];
  }

  get chanceToBeatOriginal() {
    let ctboSortKey = `${this.args.ctboMeasureName}CTBO`;

    return (this.variation as any)[ctboSortKey];
  }

  @action
  trackNavigateCampaign() {
    let destination = 'campaign';

    if (this.args.splitAction.campaignType === CampaignType.APITriggered) {
      destination = 'broadcast';
    }

    return this.args.trackNavigate(destination);
  }
}
